<script>
  import { createEventDispatcher } from 'svelte';

  let className = undefined;
  export {className as class};

  export let isActive = false;
  
  /**
   * Is this the principal call to action on the page?
   */
  export let primary = false;

  /**
   * What background color to use
   */
  export let backgroundColor;
  /**
   * How large should the button be?
   */
  export let size = 'medium';
  /**
   * Button contents
   */
  export let label = '';

  export let isFullWidth = false;

  let mode = primary ? 'UC-button--primary' : 'UC-button--secondary';

  let style = (backgroundColor ? `background-color: ${backgroundColor};` : '') + (isFullWidth ? 'width: 100%' : '');

  const dispatch = createEventDispatcher();

  /**
   * Optional click handler
   */
  function onClick(event) {
    dispatch('click', event);
  }
</script>

<button
  type="button"
  class={ ['UC-button', `UC-button--${size}`, mode, className, isActive ? 'active':''].join(' ') }
  { style }
  on:click={ onClick }>
  {label}
</button>

<style>
  .UC-button {
  font-family: inherit;
  font-weight: 700;
  border: 0;
  border-radius: 0.5rem;
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  transition: all ease-in-out 0.3s;
  }

  .UC-button--primary {
  color: white;
  background-color: #1ea7fd;
  }

  .UC-button--secondary {
  background-color: #fff;
  border: solid 2px #d7d7d7;
  color: #e00122;
  }

  .UC-button--small {
  font-size: 1em;
  padding: 10px 15px;
  }

  .UC-button--medium {
  font-size: 0.8em;
  padding: 10px 15px;
  }

  .UC-button--large {
  font-size: 16px;
  padding: 12px 24px;
  }

  .active, .UC-button:hover,  .UC-button:focus {
  color: #FFF;
  background-color: #e00122;
  border: solid 2px #e00122;
  }
</style>